import { useEffect, useMemo, useState } from "react";
import { Button, Card, Container, HeaderBar, Loader, Toast as toast, TypoGraph } from "components";
import { createUserGroup, getUserGroups } from "api";
import { ICreateUserGroupRequest, IUserGroup } from "interfaces";
import styles from "./userGroupsPage.module.scss";

const UserGroupsPage = () => {
  const [loading, setLoading] = useState(true);
  const [groups, setGroups] = useState<IUserGroup[]>([]);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState("");
  const [newCompanyCards, setNewCompanyCards] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getUserGroups();
      setGroups(res.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const sortedGroups = useMemo(() => {
    return [...groups].sort((a, b) => a.name.localeCompare(b.name));
  }, [groups]);

  const handleCreate = async () => {
    setCreating(true);
    try {
      const payload: ICreateUserGroupRequest = {
        name: newName,
        receivablesHomeByCompany: newCompanyCards,
      };
      await createUserGroup(payload);
      toast({ title: "Success", subTitle: "User group created" });
      setNewName("");
      setNewCompanyCards(true);
      await load();
    } finally {
      setCreating(false);
    }
  };

  return (
    <Container className={styles.container}>
      <HeaderBar title="User Groups" />
      <Loader loading={loading} />

      <Container className={styles.createCardContainer}>
        <Card sxContent={{ display: "grid", gridGap: "10px" }}>
          <TypoGraph variant="h3" content="Create group" />
          <label>
            <TypoGraph variant="body2" content="Group name" />
            <input
              className={styles.input}
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="e.g. LossDraftCompanyCards"
            />
          </label>
          <label className={styles.checkboxRow}>
            <input
              type="checkbox"
              checked={newCompanyCards}
              onChange={(e) => setNewCompanyCards(e.target.checked)}
            />
            <TypoGraph
              variant="body2"
              content="Receivables landing: company cards (Loss Draft)"
            />
          </label>
          <Button
            id="createUserGroup"
            label="Create"
            variant="contained"
            disabled={!newName}
            loading={creating}
            onClick={handleCreate}
          />
        </Card>
      </Container>

      <Container className={styles.listContainer}>
        {sortedGroups.map((g) => (
          <Card key={g.id} sxContent={{ display: "grid", gridGap: "8px" }}>
            <TypoGraph variant="h3" content={g.name} />
            <TypoGraph
              variant="body2"
              content={`Receivables company cards: ${g.receivablesHomeByCompany ? "Enabled" : "Disabled"}`}
            />
          </Card>
        ))}
      </Container>
    </Container>
  );
};

export default UserGroupsPage;

